// extracted by css-extract-rspack-plugin
export default {"explorer":"GraphQLExplorerPage_explorer__S16Xt"};